export default __webpack_public_path__ + "static/media/AgentUser.778b065e.svg";